export default "__VITE_ASSET__C53XA$VW__"